export default __webpack_public_path__ + "static/media/slot.3d65ecad.glb";